import { HttpInterceptorFn } from '@angular/common/http'
import { RecaptchaService } from '@app/services/recaptcha.service'
import { environment } from '@env/environment'
import { inject } from '@angular/core'
import { switchMap } from 'rxjs/operators'
import { from } from 'rxjs'

const protectedPaths = [
    '/customer',
    '/processes/',
    '/suppliers'
]

export const recaptchaInterceptor: HttpInterceptorFn = (request, next) => {
    // Só o BFF valida o reCAPTCHA. URLs pré-assinadas do S3 também podem conter `/processes/` no caminho,
    // e headers extras nelas quebram a requisição.
    if (!request.url.startsWith(environment.urlApi)) {
        return next(request)
    }

    const path = request.url.slice(environment.urlApi.length)
    const isProtected = protectedPaths.some((protectedPath) => path.startsWith(protectedPath))

    if (!isProtected) {
        return next(request)
    }

    const action = resolveRecaptchaAction(path)
    const recaptchaService = inject(RecaptchaService)

    return from(recaptchaService.execute(action)).pipe(
        switchMap((token) => next(request.clone({
            setHeaders: {
                'x-recaptcha-token': token,
                'x-recaptcha-action': action
            }
        })))
    )
}

export function resolveRecaptchaAction(path: string): string {
    if (path.startsWith('/customer')) {
        return 'customer'
    }

    if (path.startsWith('/suppliers')) {
        return 'suppliers'
    }

    if (path.startsWith('/processes/supplier-enrollment-notice')) {
        return 'enrollment'
    }

    if (path.includes('/notice-download/')) {
        return 'download'
    }

    if (path.includes('/details')) {
        return 'details'
    }

    return 'search'
}
